import { LabelHTMLAttributes } from "react";

import * as S from "./styles";

type LabelProps = LabelHTMLAttributes<HTMLLabelElement>;

export function Label({ children }: LabelProps) {
  return <S.Label>{children}</S.Label>;
}
